import React from 'react'
import { useFlatFormFields } from '@hooks/useFlatFormFields'
import { Col, Row } from 'antd'
import Field from '@components/Field/Field'
import { useWidgetCollapse } from '@hooks/useWidgetCollapse'
import { RowMeta } from '@interfaces/rowMeta'
import { AdditionalInfoWidgetMeta } from '@interfaces/widget'
import { AdditionalInfoHeader } from '@components/widgets/AdditionalInfo/AdditionalInfoHeader'
import styles from './AdditionalInfoItem.module.css'
import FieldBaseThemeWrapper from '@components/FieldBaseThemeWrapper/FieldBaseThemeWrapper'

interface Props {
    meta: AdditionalInfoWidgetMeta
    cursor: string | undefined | null
    rowMeta?: RowMeta
}

export const AdditionalInfoItem: React.FC<Props> = ({ meta, cursor, rowMeta }) => {
    const { options, fields: widgetFields } = meta

    const flattenWidgetFields = useFlatFormFields(widgetFields || [])
    const { isMainWidget, isCollapsed } = useWidgetCollapse(meta.name)

    return (
        <>
            <AdditionalInfoHeader meta={meta} id={cursor} level={2} />
            {!(isMainWidget && isCollapsed) &&
                options?.layout?.rows.map((row, rowIndex) => {
                    return (
                        <Row key={rowIndex} gutter={[8, 18]}>
                            {(rowMeta
                                ? row.cols.filter(field => {
                                      const fieldMeta = rowMeta.fields?.find(f => f.key === field.fieldKey)
                                      return fieldMeta ? !fieldMeta.hidden : true
                                  })
                                : row.cols
                            ).map(col => {
                                const field = flattenWidgetFields.find(f => f.key === col.fieldKey)

                                return field ? (
                                    <React.Fragment key={col.fieldKey}>
                                        <Col span={12} className={styles.rowLabel}>
                                            {field.label}
                                        </Col>
                                        <Col span={12}>
                                            <FieldBaseThemeWrapper
                                                data-test="FIELD"
                                                data-test-field-type={field.type}
                                                data-test-field-title={field.label || field.title}
                                                data-test-field-key={field.key}
                                            >
                                                <Field
                                                    className={styles.fieldOverride}
                                                    bcName={meta.bcName}
                                                    cursor={cursor || ''}
                                                    widgetName={meta.name}
                                                    widgetFieldMeta={field}
                                                    readonly={true}
                                                />
                                            </FieldBaseThemeWrapper>
                                        </Col>
                                    </React.Fragment>
                                ) : null
                            })}
                        </Row>
                    )
                })}
        </>
    )
}
